export enum ReactionTypes {
  Love = 'love',
  Like = 'like',
  Dislike = 'dislike',
  Haha = 'haha',
  Strong = 'strong',
  Prayers = 'prayers',
  Sad = 'sad',
  Angry = 'angry',
  Celebrate = 'celebrate',
  Sick = 'sick',
}
